(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/bankid/bankid-service.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/bankid/bankid-service.js');
"use strict";


const {
  jupiter
} = svs.core;
const {
  logger
} = svs.playerLoginReact;

const getBankIdAutoStartTokenAsync = async () => {
  try {
    const options = {
      method: 'POST',
      path: '/player/1/authenticate',
      data: {}
    };
    svs.components.Storage.browser.set('loginStartTime', 'player-login', Date.now(), svs.components.Storage.constants.EXPIRES_10M, () => {});
    const {
      response
    } = await jupiter.callAsync(options);
    return {
      autoStartToken: response.autoStartToken,
      qrData: response === null || response === void 0 ? void 0 : response.qrData
    };
  } catch (err) {
    const errorCodes = [1, 41, 42];
    if (errorCodes.includes(err === null || err === void 0 ? void 0 : err.code)) {
      logger.warn('Error starting bankid login', err);
    } else {
      logger.info('Error starting bankid login', err);
    }
    throw err;
  }
};
const source = {
  'ios-hybrid-mobile': 5,
  'android-hybrid-mobile': 5,
  'ios-hybrid-tablet': 6,
  'web-mobile': 1,
  'web-tablet': 2,
  'web-desktop': 3
};

const pollCustomerLoginAsync = async autoStartToken => {
  try {
    const options = {
      method: 'POST',
      path: '/player/1/authenticate/login',
      data: {
        autoStartToken,
        source: source[svs.core.data.capabilities.channel] || 1
      }
    };
    const {
      response
    } = await jupiter.callAsync(options);
    return response;
  } catch (err) {
    logger.warn('Error polling bankid login', err);
    throw err;
  }
};
const cancelCustomerLoginAsync = async autoStartToken => {
  try {
    const options = {
      method: 'POST',
      path: '/player/1/cancel',
      context: void 0,
      data: {
        autoStartToken
      }
    };
    const response = await svs.core.jupiter.callAsync(options);
    logger.info("Cancel poll: ".concat(response));
  } catch (error) {
    const errorCode = error === null || error === void 0 ? void 0 : error.code;
    logger.info(errorCode);
  }
};
svs.playerLoginReact.bankid.BankidService = {
  getBankIdAutoStartTokenAsync,
  pollCustomerLoginAsync,
  cancelCustomerLoginAsync
};

 })(window);